import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import AcuraIncludedIcon from './icons/AcuraIncludedIcon';
import HondaIncludedIcon from './icons/HondaIncludedIcon';
const IncludedBadge = ({ isVariant }) => {
    const { t } = useTranslation();
    const isIncludedLabel = t('Pages.Bap.includedLabel');
    if (isVariant) {
        return (React.createElement(View, { style: {
                borderRadius: '100px',
                backgroundColor: '#EAEAEA',
                padding: '6px 8px 6px 8px',
                flexDirection: 'row',
                alignItems: 'center',
                width: 'auto',
                flexGrow: 0,
                flexShrink: 1,
                alignSelf: 'flex-start',
            } },
            React.createElement(AcuraIncludedIcon, null),
            React.createElement(Text, { style: {
                    fontSize: '10px',
                    fontWeight: 'bold',
                    letterSpacing: '0.5px',
                    color: '#334C96',
                    marginLeft: '4px',
                } }, isIncludedLabel)));
    }
    return (React.createElement(View, { style: {
            borderRadius: '3px',
            backgroundColor: '#EAEAEA',
            padding: '6px 8px 6px 8px',
            flexDirection: 'row',
            alignItems: 'center',
            width: 'auto',
            flexGrow: 0,
            flexShrink: 1,
            alignSelf: 'flex-start',
        } },
        React.createElement(HondaIncludedIcon, null),
        React.createElement(Text, { style: {
                paddingTop: '4px',
                fontSize: '10px',
                fontWeight: 'bold',
                letterSpacing: '0.5px',
                color: '#004478',
                marginLeft: '4px',
            } }, isIncludedLabel)));
};
export default IncludedBadge;
